<script>
export default {
  name: 'custom-seat-specs',
  props: {
    specs: {
      type: Object,
      default: () => {}
    },
    showLastFoamType: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<template>
  <div>
    <p class="p-0 my-2 mb-2">
      <i class="text-muted mr-2">{{ $t(`attribute.model_type.key`) }}: </i>
      <template v-if="specs.other_model_type">
        <span class="mr-2">{{ $t(`attribute.model_type.other`) }}...</span>
        <i class="">"{{ specs.other_model_type }}"</i>
      </template>
      <template v-else>
        {{
          $t(`attribute.model_type.value`, {
            value: $t(`attribute.model_type.${specs.model_type}`)
          })
        }}
      </template>
    </p>

    <p class="p-0 m-0 mb-2" v-if="specs.last_foam_type && showLastFoamType">
      <i class="text-muted mr-2">{{ $t(`attribute.foam_type.key`) }}: </i>
      <template v-if="specs.last_foam_type === 'mix'">
        <span class="mr-3">{{ $t('attribute.foam_type.mix') }}</span>

        <strong class="text-uppercase mr-2">{{ $t('Seat:') }}</strong>
        {{
          $t(`attribute.foam_type.value`, {
            value: $t(`attribute.foam_type.${specs.last_mix_seat_foam_type}`)
          })
        }}

        <strong class="text-uppercase ml-4 mr-2">{{ $t('Back:') }} </strong>
        {{
          $t(`attribute.foam_type.value`, {
            value: $t(`attribute.foam_type.${specs.last_mix_back_foam_type}`)
          })
        }}
      </template>
      <template v-else>
        {{
          $t(`attribute.foam_type.value`, {
            value: $t(`attribute.foam_type.${specs.last_foam_type}`)
          })
        }}
      </template>
    </p>

    <p class="p-0 m-0 mb-2" v-else>
      <i class="text-muted mr-2">{{ $t(`attribute.foam_type.key`) }}: </i>
      <template v-if="specs.foam_type === 'mix'">
        <span class="mr-3">{{ $t('attribute.foam_type.mix') }}</span>

        <strong class="text-uppercase mr-2">{{ $t('Seat:') }}</strong>
        {{
          $t(`attribute.foam_type.value`, {
            value: $t(`attribute.foam_type.${specs.mix_seat_foam_type}`)
          })
        }}

        <strong class="text-uppercase ml-4 mr-2">{{ $t('Back:') }} </strong>
        {{
          $t(`attribute.foam_type.value`, {
            value: $t(`attribute.foam_type.${specs.mix_back_foam_type}`)
          })
        }}
      </template>
      <template v-else>
        {{
          $t(`attribute.foam_type.value`, {
            value: $t(`attribute.foam_type.${specs.foam_type}`)
          })
        }}
      </template>
    </p>

    <p class="p-0 m-0 mb-2">
      <i class="text-muted mr-2">{{ $t(`attribute.offset_3d.key`) }}: </i>
      {{
        $t(`attribute.offset_3d.value`, {
          value: specs.offset_3d
        })
      }}
    </p>

    <p class="p-0 m-0 mb-2">
      <i class="text-muted mr-2">{{ $t(`attribute.widen.key`) }}: </i>
      {{
        $t(`attribute.widen.value`, {
          value: specs.widen
        })
      }}
    </p>

    <p class="p-0 m-0 mb-2">
      <i class="text-muted mr-2">{{ $t(`attribute.lengthen.key`) }}: </i>
      {{
        $t(`attribute.lengthen.value`, {
          value: specs.lengthen
        })
      }}
    </p>

    <p class="p-0 m-0 mb-2">
      <i class="text-muted mr-2">{{ $t(`attribute.inclination.key`) }}: </i>
      <template v-if="!!specs.inclination_custom">
        <span class="mr-2">{{ $t(`attribute.inclination.custom`) }}...</span>
        <i class=""
          >"{{
            $t(`attribute.inclination_custom.value`, {
              value: specs.inclination_custom
            })
          }}"</i
        >
      </template>
      <template v-else>
        {{
          $t(`attribute.inclination.value`, {
            value: $t(`attribute.inclination.${specs.inclination}`)
          })
        }}
      </template>
    </p>

    <p class="p-0 m-0 mb-2">
      <i class="text-muted mr-2">{{ $t(`attribute.symmetrization.key`) }}: </i>
      <template v-if="!!specs.symmetrization">
        {{
          $t(`attribute.symmetrization.value`, {
            value: $t(`attribute.symmetrization.${specs.symmetrization}`)
          })
        }}
      </template>
      <template v-else>
        {{ $t(`attribute.symmetrization.none`) }}
      </template>
    </p>

    <p class="p-0 m-0 mb-2">
      <i class="text-muted mr-2">{{ $t(`attribute.max_foam_width.key`) }}: </i>
      <template v-if="!!specs.max_foam_width">
        {{
          $t(`attribute.max_foam_width.value`, {
            value: $t(`attribute.max_foam_width.${specs.max_foam_width}`)
          })
        }}
      </template>
      <template v-else>
        {{ $t(`attribute.max_foam_width.none`) }}
      </template>
    </p>

    <template v-if="specs.build_casing">
      <h6 class="mt-4">{{ $t('Build Alumnium Casing') }}</h6>

      <div class="p-0 m-0 my-3" v-if="specs.add_head_support">
        <span class="text-muted">
          <i class="far fa-check-square mr-2 mb-1"></i>
          {{ $t('Add Head Support System') }}
        </span>

        <div class="text-capitalize ml-4 mt-2">
          <i class="text-muted mr-2">{{ $t(`attribute.size.key`) }}: </i>
          <span class="text-capitalize">{{
            $t(`attribute.size.value`, {
              value: $t(`attribute.size.${specs.head_support_foam_size}`)
            })
          }}</span>

          <span
            class="ml-1 text-capitalize"
            v-if="specs.head_support_foam_size !== 'milled'"
            >{{
              $t(`attribute.head_support_foam_model.value`, {
                value: specs.head_support_foam_model
              })
            }}
          </span>
        </div>
      </div>

      <div class="p-0 m-0 my-3" v-if="specs.add_foot_support">
        <span class="text-muted">
          <i class="far fa-check-square mr-2 mb-0"></i>
          {{ $t('Add Foot Support System') }}
        </span>

        <div class="text-capitalize ml-4 mt-2">
          <i class="text-muted mr-2">{{ $t(`attribute.tube_length.key`) }}: </i>
          {{
            $t(`attribute.tube_length.value`, {
              value: specs.foot_support_tube_length
            })
          }}
        </div>
        <div class="text-capitalize ml-4 mt-2">
          <i class="text-muted mr-2"
            >{{ $t(`attribute.foot_support_abs_plate.key`) }}:
          </i>
          <template v-if="specs.foot_support_abs_plate !== 'none'">
            {{
              $t(`attribute.foot_support_abs_plate.value`, {
                value: specs.foot_support_abs_plate
              })
            }}
          </template>
          <template v-else>
            {{ $t(`attribute.foot_support_abs_plate.none`) }}
          </template>
        </div>

        <div class="text-capitalize ml-4 mt-2">
          <i class="text-muted mr-2"
            >{{ $t(`attribute.foot_support_footplates.key`) }}:
          </i>
          <template v-if="specs.foot_support_footplates !== 'none'">
            {{
              $t(`attribute.foot_support_footplates.value`, {
                value: specs.foot_support_footplates
              })
            }}
          </template>
          <template v-else>
            {{ $t(`attribute.foot_support_footplates.none`) }}
          </template>
        </div>
      </div>

      <div class="p-0 m-0 my-3" v-if="specs.add_abduction">
        <span class="text-muted">
          <i class="far fa-check-square mr-2 mb-1"></i>
          {{ $t('attribute.add_abduction.key') }}
        </span>
      </div>

      <div class="p-0 m-0 my-3" v-if="specs.add_arm_support">
        <span class="text-muted">
          <i class="far fa-check-square mr-2 mb-1"></i>
          {{ $t('attribute.add_arm_support.key') }}
        </span>
      </div>

      <div class="p-0 m-0 my-3" v-if="specs.add_table_system">
        <span class="text-muted">
          <i class="far fa-check-square mr-2 mb-1"></i>
          {{ $t('attribute.add_table_system.key') }}
        </span>
      </div>
    </template>
  </div>
</template>
